import React from 'react'
import "./style.css"
const Loader = props => { return <div className="loader" style={props.style}></div> }

export default Loader;